import { axiosInstance } from "@/api/axiosInstance"
import { AxiosRequestConfig } from "axios"
import { SearchEducationRequest } from "swagger/models"
import { EducationApi } from "../../swagger/api"
import { Configuration } from "../../swagger/configuration"
import { getFirebaseIDToken } from "./auth/firebase"

const getAccessToken = async () => {
  const accessToken = await getFirebaseIDToken()
  return accessToken
}

const getApiConfig = () =>
  new Configuration({
    basePath: process.env.NEXT_PUBLIC_API_URL,
    //@ts-ignore
    accessToken: getAccessToken,
  })

const apiConfiguration = getApiConfig()

const COMICS_API = new EducationApi(apiConfiguration, apiConfiguration.basePath, axiosInstance)

export const getEducationBySlug = async (educationSlug: string, options?: AxiosRequestConfig) =>
  COMICS_API.getEducationBySlug(educationSlug, options)

export const searchEducations = async (
  body: SearchEducationRequest,
  page?: number,
  size?: number,
  sort?: Array<string>,
  options?: AxiosRequestConfig,
) => COMICS_API.searchEducation(body, page, size, sort, options)
